import getIsLoyaltyEnabled from './getIsLoyaltyEnabled'

/**
 * Whether Société burn UX is enabled on experience search.
 * Uses the standard loyalty rollout gates (config + luxLoyaltyFeatureToggle),
 * but not the Société burn A/B test.
 */
function getIsExperienceLoyaltyBurnEnabled(state: App.State): boolean {
  return getIsLoyaltyEnabled(state)
}

export default getIsExperienceLoyaltyBurnEnabled
